import React, { ReactElement } from 'react';

import { IParentProps } from '../../shared/types/IParentProps';
import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import styles from './Grid.module.css';

export type IGridProps = IParentProps & IQATestableProps & IStyleableProps;

export function OzGrid (props: IGridProps): ReactElement {
    const {
        className = '',
        children,
        'data-testid': dataTestId,
    }: IGridProps = props;

    return (
        <div className={`${className} ${styles.host} flex flex-wrap`} data-testid={dataTestId}>{children}</div>
    );
}
